import {
  classNames,
  Tag,
  TagBlockProps,
} from '@payfit/growth-platform-brand-system-v2';
import { fontCaptionMedium } from '@payfit/growth-platform-brand-system-v2/styles/typographyNew';
import { LabelsMonthFreeRecord } from 'apps/website/types/dato';
import React from 'react';

const FreeMonths = ({
  monthFreeFrequencyLabel,
  tag,
}: LabelsMonthFreeRecord) => {
  return (
    <div
      className={classNames(
        'PriceBreakdown_Calculation',
        'flex items-center justify-between gap-x-16',
      )}
    >
      <div className={classNames(fontCaptionMedium)}>
        {monthFreeFrequencyLabel}
      </div>
      {tag && (
        <div className="w-fit">
          <Tag color={tag.color as TagBlockProps['color']}>{tag.title}</Tag>
        </div>
      )}
    </div>
  );
};

export default FreeMonths;
